import React from 'react';
import Button from 'components/shared/generic/button/presentational/Button';
import useTranslate from 'lib/languages/useTranslate';
import { CardStatus } from 'lib/type/enums';
import clsx from 'clsx';

interface DisabledCardProps {
    position: string;
    onClick: () => void;
    isDarkText?: boolean;
    status: CardStatus;
}

const DisabledCard: React.FC<DisabledCardProps> = ({
    position,
    onClick,
    isDarkText = false,
    status,
}) => {
    const ifTerminated = status === CardStatus.TERMINATED;
    const showButton = position === 'center' && ifTerminated;
    const translate = useTranslate('cards.cardSlider');
    const statusTitleMap = {
        [CardStatus.TERMINATED]: 'cardFrozen',
        [CardStatus.RISK]: 'cardUnderReview',
    };
    return (
        <div
            className={clsx('content', 'frozen-card', {
                'dark-text': isDarkText,
            })}
        >
            <i className="icon fa fa-lock-alt"></i>
            <p className="title">{translate(statusTitleMap[status])}</p>
            {showButton && (
                <Button onClick={onClick}>
                    {translate('orderReplacement')}
                </Button>
            )}
        </div>
    );
};

export default DisabledCard;
